// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__V7Ko4","article":"not-found_article__UrVUd"};